import React, { useCallback, useContext, useEffect, useMemo, useRef } from "react";
import { DataLayerService } from "@ipru-common/libs/DataLayer/DataLayerService";
// import GlobalStore from "@ipru-common/store/GlobalStore";
import { DataLayerContext as SharedDataLayerContext } from "shared-library";

// const SharedDataLayerContext = createContext();

export const DataLayerProvider = ({ children, globalState }) => {
  const globalRef = useRef(globalState);

  useEffect(() => {
    globalRef.current = globalState;
  }, [globalState]);

  /**
   * Pushes an event to the data layer.
   * @param {PushToDataLayerParams} params - The data object.
   */
  const pushToDataLayer = useCallback(async ({ currentSection, event, eventData, buttonText = "", question = "" }) => {
    setTimeout(() => {
      DataLayerService.pushEvent({
        ...globalRef.current,
        event,
        eventData,
        buttonText,
        question,
        sectionName: currentSection,
      });
    }, 500);
  }, []);

  // Memoize the context value
  const contextValue = useMemo(() => {
    return { pushToDataLayer };
  }, [pushToDataLayer]);

  return <SharedDataLayerContext.Provider value={contextValue}>{children}</SharedDataLayerContext.Provider>;
};

/**
 * Hook to use the DataLayer context.
 * @returns {PushToDataLayerFunction}
 */
export const useDataLayer = () => {
  const context = useContext(SharedDataLayerContext);
  if (!context) {
    throw new Error("useDataLayer must be used within a DataLayerProvider");
  }
  return context.pushToDataLayer;
};
